export default "__VITE_ASSET__BKBMQdaN__"